export enum AnalyticsEventsEnum {
  FeedTap = 'Feed_Tap',

  // FeedAppear = 'Feed_Appear',
  FeedModalAppear = 'Feed_Modal_Appear',

  CreateTap = 'Create_Tap',

  EarnTap = 'Earn_Tap',

  MarketTap = 'Market_Tap',

  MyProfileTap = 'MyProfile_Tap',

  MediaPlayTap = 'Media_Play_Tap',
  MediaPauseTap = 'Media_Pause_Tap',
  MediaLikeTap = 'Media_Like_Tap',
  MediaCommentTap = 'Media_Comment_Tap',
  MediaShareTap = 'Media_Share_Tap',
  MediaMenuTap = 'Media_Menu_Tap',
  MediaUserTap = 'Media_User_Tap',

  DonateValueTap = 'Donate_Value_Tap',

  FeedEasyTap = 'Feed_Easy_Tap',

  ModalGoToCheeleeTap = 'Modal_Go_To_Cheelee_Tap',

  GameParametersUnauthorizedTap = 'GameParameters_Unauthorized_Tap',

  TipsTap = 'Tips_Tap',

  VolumeTap = 'Volume_Tap',

  UserSettingsTap = 'User_Settings_tap',

  MarketGlassesCellTap = 'Offer_Glasses_Appear',
  OfferGlassesAppear = 'Offer_Glasses_Appear',
  OfferGlassesBuyTap = 'Offer_Glasses_Buy_Tap',
  MarketCheckoutAppear = 'Market_Checkout_Appear',
  MarketCheckoutBuyTap = 'Market_Checkout_Buy_Tap',
}
